import { Injector } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { ToastrService } from 'ngx-toastr'
import { LoginService } from './services/login.service'

declare var require: any
const Swal = require('sweetalert2')

export abstract class AppComponentBase {
  _translateService: TranslateService
  _toastr: ToastrService
  authService: LoginService
  active: boolean = true
  formValid: boolean = false
  formSubmitted: boolean = false
  formReseted: boolean = false
  showList: boolean = true
  showForm: boolean = false
  editForm: boolean = false
  formId: number = 0
  pageSize: any = 10
  page: any = 1
  total: any

  get isDirRTL() {
    return this._translateService.currentLang == 'ar'
  }

  constructor(injector: Injector) {
    this._translateService = injector.get(TranslateService)
    this._toastr = injector.get(ToastrService)
    this.authService = injector.get(LoginService)
  }

  cancelForm() {
    this.showList = true;
    this.showForm = false;
    this.editForm = false;
  }
  

  clone(source: any) {
    return JSON.parse(JSON.stringify(source))
  }

  //--------------------- Notify-------------------
  showError(message?: any, title?: any, option?: any) {
    // if (message)
    //     this._toastr.error(message)
    // if (message && title)
    //     this._toastr.error(message, title)
    // if (message && title && option)
    this._toastr.error(message, title, option)
  }

  showSuccess(message?: any, title?: any, option?: any) {
    if (!message) message = this.l('success-message')

    this._toastr.success(message, title, option)
  }

  

  showErrors(errors: any) {
    console.log(errors);
    let isErrorsArray = Array.isArray(errors)

    console.log(isErrorsArray);
    

    if (isErrorsArray) {
      for (const error in errors.error.errors) {
        console.log(`${error}: ${errors.error.errors[error]}`);
        this._toastr.error(errors.error.errors[error])
      }
    } else {
      this._toastr.error(errors.error.message)
    }
    
    if (errors.error.message.includes('Unauthenticated')) {
      this.authService.Logout()
    }
  }

  showMessage(successOrError: string, title: string, text: string) {
    Swal.fire({
      icon: successOrError == 'success' ? 'success' : 'error',
      title,
      text
    })
  }

  //-----------------------localization-------------
  l(key: any, values?: any) {
    return this._translateService.instant(key, values)
  }

  handleError(error: any) {

    if (error['error']) this.showError(this.isDirRTL ? error['error'].messageAr : error['error'].messageEn, 'Assign Error', { positionClass: 'toast-top-right' })
    else this.showError(error.message, 'Assign Error')
  }
}
